/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.controls.js"/>
/// <reference path="skyward.ui.ajax.js"/>
/// <reference path="skyward.ui.validation.ts"/>
/// <reference path="skyward.ui.contentMessageArea.js"/>
/// <reference path="skyward.ui.events.ts"/>
/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.foodservice = skyward.foodservice || {};

        var customerPINvalue;
        var nameID;
        var effectiveTime;

        var init = function (selector)
        {
            var itemPriceItemLimit = $(selector).find(".itemPriceItemLimit");
            if (itemPriceItemLimit.length !== 0)
            {
                itemPriceItemLimit.on('focusout', skyward.foodservice.enforceAdditionalPurchaseAmount);
                $.each(itemPriceItemLimit, function () {
                    skyward.foodservice.enforceAdditionalPurchaseAmount.bind(this)();
                });
            }

            $('input[name*="StopAdditionalPurchases"]').each(function ()
            {
                $(this).on("click", skyward.foodservice.enforceAdditionalPurchaseAmount);
            });

            var updateCustomerCategoryDefaults = $(selector).find(".updateCustomerCategoryDefaults");
            if (updateCustomerCategoryDefaults.length !== 0)
            {
                nameID = null;
                effectiveTime = null;

                var districtID = $(selector).find("[name=Customer_DistrictID]");
                var isWorkflow = $(selector).find("[name=Customer_IsWorkflow]");

                updateCustomerCategoryDefaults.off('datePickerChangeComplete.foodservice');
                updateCustomerCategoryDefaults.off('change.foodservice');
                $.each(updateCustomerCategoryDefaults, function ()
                {
                    var control = $(this);
                    if (control.hasClass('datepicker'))
                    {
                        effectiveTime = skyward.controls.getValue(control);
                        control.on('datePickerChangeComplete.foodservice', function () { skyward.foodservice.updateCustomerCategoryDefaults.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                    }
                    else
                    {
                        control.on('change.foodservice', function () { skyward.foodservice.updateCustomerCategoryDefaults.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                    }
                });

                var generatePINButton = $(selector).find("#GenerateCustomerPINButton");
                if (generatePINButton.length === 0)
                {
                    generatePINButton = $(selector).find("#editCustomer_GenerateCustomerPINButton");
                    nameID = $(selector).find("[name=Customer_NameID]").val();
                }

                if (generatePINButton.length !== 0)
                {
                    generatePINButton.off('click.foodservice');
                    generatePINButton.on('click.foodservice', function () { skyward.foodservice.generateCustomerPIN.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                }
            }
        };

        skyward.foodservice.generateCustomerPIN = function (selector, districtID, isWorkflow)
        {
            var url;
            if (isWorkflow === 'true')
            {
                url = 'GenerateNewCustomerPINAdd';
            }
            else
            {
                url = 'GenerateNewCustomerPINDetails';
            }

            updateDefaults(selector, districtID, isWorkflow, url, false);
        };

        skyward.foodservice.updateCustomerCategoryDefaults = function (selector, districtID, isWorkflow)
        {
            var thisControl = $(this);
            if (thisControl && (thisControl[0].name === "Customer.NameID" || thisControl[0].name === "Payor.NameID"))
            {
                nameID = skyward.controls.getValue(thisControl);
            }
            else
            {
                effectiveTime = skyward.controls.getValue(thisControl);
            }

            var customerPIN = $(selector).find("[id=CustomerPIN]");
            if (customerPIN !== undefined)
            {
                customerPINvalue = skyward.controls.getValue(customerPIN);
            }

            if (nameID && effectiveTime && Object.prototype.toString.call(effectiveTime) === "[object Date]" && !isNaN(effectiveTime.getTime()))
            {
                updateDefaults(selector, districtID, isWorkflow, 'UpdateCustomerCategoryDefaults', true);
            }
        };

        var updateDefaults = function (selector, districtID, isWorkflow, url, generatePIN, previousData)
        {
            $.ajax({
                url: skyward.global.virtualDir + "FoodService/Customer/" + url,
                type: 'POST',
                dataType: 'JSON',
                cache: false,
                data:
                {
                    Customer_NameID: nameID,
                    Customer_DistrictID: districtID,
                    Customer_EffectiveTime: effectiveTime ? effectiveTime.safeToDateString() : "",
                    Customer_IsWorkflow: isWorkflow,
                    Customer_PIN: customerPINvalue
                },
                success: function (data)
                {
                    if (generatePIN && !data.warnings["CustomerCategory.EffectiveTime"])
                    {
                        var url;
                        if (isWorkflow === 'true')
                        {
                            url = 'GenerateNewCustomerPINAdd';
                        }
                        else
                        {
                            url = 'GenerateNewCustomerPINDetails';
                        }

                        updateDefaults(selector, districtID, isWorkflow, url, false, data);
                    }
                    else
                    {
                        var container = $(selector);
                        var baseErrorContainer = container.find("#baseWorkflowErrorContainer");
                        if (previousData)
                        {
                            $.extend(true, previousData, data);
                            data = previousData;
                        }
                        skyward.ajax.handleResponse(data, "", false, skyward.window.getClosestContentPanel(container));
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }
            });
        };

        skyward.foodservice.enforceAdditionalPurchaseAmount = function ()
        {
            var thisControl = $(this);
            var controlName = thisControl.attr('name');
            var controlPrefix = '';
            var itemLimitOverride = undefined;

            if (controlName == 'ItemLimitAdd' || controlName.split('.').length > 1) // Need to prefix for ItemPrice Update workflow
            {
                itemLimitOverride = "#ItemLimitAdd";

                if (controlName.split('.').length > 1)
                {
                    controlPrefix = controlName.split('.')[0];
                }
                else
                {
                    controlPrefix = "ItemPrice";
                }
            }

            var parentBrowse = thisControl.parents("#itemPriceContainer"); //Complete Pricing Workflow
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItem_itemPriceContainer"); //Item Details + Winkel
            }
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItemPrice_itemPriceContainer"); //ItemPrice Details
                controlPrefix = "editItemPrice_";
            }

            var controlID = controlName.split("-")[1];
            var isBrws = controlID !== undefined && controlID.length > 1;
            if (parentBrowse[0] !== undefined)
            {
                var itemPriceItemLimitField = "#ItemLimit";
                if (isBrws)
                {
                    itemPriceItemLimitField = '#ItemLimit-' + controlID;
                }
                else
                {
                    if (itemLimitOverride !== undefined)
                    {
                        itemPriceItemLimitField = itemLimitOverride;
                    }
                    else
                    {
                        itemPriceItemLimitField = '#' + controlPrefix + 'ItemLimit';
                    }
                }
                var stopAdditionalChkField = isBrws ? '#StopAdditionalPurchases-' + controlID : '#' + controlPrefix + 'StopAdditionalPurchases';
                var additionalPurchaseNbrField = isBrws ? '#AdditionalPurchaseAmount-' + controlID : '#' + controlPrefix + 'AdditionalPurchaseAmount';

                var itemPriceItemLimit = parentBrowse.find(itemPriceItemLimitField);
                var stopAdditionalChk = parentBrowse.find(stopAdditionalChkField);
                var additionalPurchaseNbr = parentBrowse.find(additionalPurchaseNbrField);

                var arrAllow = [];
                var arrDisab = [];
                var thisDiv = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'divAdditionalPurchases');
                var thisRow = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'rowAdditionalAmount');

                if (additionalPurchaseNbr[0] !== undefined && stopAdditionalChk[0] !== undefined)
                {
                    if (skyward.controls.getValue(itemPriceItemLimit) !== "" && skyward.controls.getValue(itemPriceItemLimit) !== "0" && skyward.controls.getValue(itemPriceItemLimit) !== "00" && skyward.controls.getValue(itemPriceItemLimit) !== "000")
                    {
                        arrAllow.push((isBrws ? stopAdditionalChk : thisDiv));
                        if (skyward.controls.getValue(stopAdditionalChk))
                        {
                            arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                            skyward.controls.setValue(additionalPurchaseNbr, null);
                        }
                        else
                        {
                            arrAllow.push((isBrws ? additionalPurchaseNbr : thisRow));
                        }
                    }
                    else
                    {
                        arrDisab.push((isBrws ? stopAdditionalChk : thisDiv));
                        arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                        skyward.controls.clearValue(stopAdditionalChk, false);
                        skyward.controls.setValue(additionalPurchaseNbr, null);
                    }

                    for (var i = 0; i < arrAllow.length; i++)
                    {
                        if (isBrws)
                        {
                            if (itemPriceItemLimit[0] !== undefined && (!(itemPriceItemLimit.attr("readonly") || itemPriceItemLimit.attr("disabled"))))
                            {
                                arrAllow[i].removeAttr("disabled readonly");
                            }
                        }
                        else
                        {
                            arrAllow[i].show();
                        }
                    }

                    for (var i = 0; i < arrDisab.length; i++)
                    {
                        if (isBrws)
                        {
                            arrDisab[i].attr({ "disabled": "disabled", "readonly": "readonly" });
                        }
                        else
                        {
                            arrDisab[i].hide();
                        }
                    }
                }
            }
        };

        skyward.foodservice.downloadSkySerial = function () {
            var MaC = navigator.userAgent.toLowerCase();
            var Win = ((MaC.indexOf("win") != -1) || (MaC.indexOf("16bit") != -1));
            MaC = (MaC.indexOf('mac') != -1);

            if (Win)
                window.open('https://www.skyward.com/files/SkyTerm/SkySerial v3 Workstation Install.exe', '_blank');
            if (MaC)
                message('There is no SkySerial application available for your operating system at this time.');
        };

        function initmonthlyreimbursementmonthdetailsschoolfilterclickevent(context)
        {
            $("#SchoolIDFilter_description").parent().click(function()
            {
                $(".detailsPreviewButton").click();
            });
        }

        var events =
        {
            "downloadSkySerial": skyward.foodservice.downloadSkySerial,
            "initmonthlyreimbursementmonthdetailsschoolfilterclickevent": initmonthlyreimbursementmonthdetailsschoolfilterclickevent
        };
        skyward.events.registerEvents("foodservice", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);